import React, { Component } from "react";
import {
  Button,
  Modal,
  Row,
  Col,
  Input,
  InputNumber,
  Radio,
  Select,
  Form,
  message,
} from "antd";
import axios from "axios";
import API_URL from "../../constants/API_URL";
import CustpmerTable from "./CustomerSetup";
import { connect } from "react-redux";
import { posStorageAction } from "../../redux/actions/posStorageAction";

const FormItem = Form.Item;

class CustomerSelect extends Component {
  constructor() {
    super();
    this.state = {
      isSelected: false,
      customerSelected: "",
      isAlreadySelected: false,
      customerSelectedName: "",
      cusPoints: 0,
      visible: false,
      branches: [],
      gender: [],
      country: [],
      customer_group: [],
      city: [],
      getDeliveryAreas: [],
      pricelist: [],
      phonenodef: "",
    };
    this.focus = this.focus.bind(this);

    this.setval = this.setval.bind(this);
  }
  componentDidMount() {
    this.getPriceList();
    this.setState({ visible: this.props.visible });
    setTimeout(() => {
      this.focus();
      this.setval();
    }, 100);

    console.log(this.props.tablenop, "tablenoptablenop");
    const storedValue = localStorage.getItem("phonenumberforadduser");
    if ((this.state.phonenodef = "")) {
      this.setState({ phonenodef: storedValue });
      console.log(this.state.phonenodef, "phonenodefphonenodefphonenodef");
    }
    // if(this.props.visible){
    //     setTimeout(() => {
    //     this.props.onBack();

    //     }, 900);
    // }
    setTimeout(() => {
      let length = document.getElementsByClassName(
        "ant-table-row ant-table-row-level-0",
      ).length;

      for (let i = 0; i <= length - 1; i++) {
        let b = document.getElementsByClassName(
          "ant-table-row ant-table-row-level-0",
        )[i].dataset.rowKey;
        if (b === this.props.posStorage.customer) {
          if (this.state.customerSelected === this.props.posStorage.customer) {
            document.getElementsByClassName(
              "ant-table-row ant-table-row-level-0",
            )[i].style.background = "";
          } else {
            this.setState({ isAlreadySelected: true });
            document.getElementsByClassName(
              "ant-table-row ant-table-row-level-0",
            )[i].style.background = "#cc0000";
          }
        } else {
          document.getElementsByClassName(
            "ant-table-row ant-table-row-level-0",
          )[i].style.background = "";
        }
      }
    }, 1000);
  }
  setval() {
    setTimeout(() => {
      let num = this.props.numval;
      console.log(num, " document.getElementById('phonenum')");
      console.log(
        document.querySelector("#phonenum"),
        " document.getElementById('phonenum')",
      );
    }, 2000);
  }
  focus() {
    this.textInput.focus();
  }
  handleNavigation = (record, rowIndex, event) => {
    let length = document.getElementsByClassName(
      "ant-table-row ant-table-row-level-0",
    ).length;
    for (let i = 0; i <= length - 1; i++) {
      let b = document.getElementsByClassName(
        "ant-table-row ant-table-row-level-0",
      )[i].dataset.rowKey;
      if (b === record.id) {
        if (this.state.customerSelected === record.id) {
          document.getElementsByClassName(
            "ant-table-row ant-table-row-level-0",
          )[i].style.background = "";
          this.setState({
            isSelected: false,
            customerSelected: "",
            customerSelectedName: "",
          });
        } else {
          document.getElementsByClassName(
            "ant-table-row ant-table-row-level-0",
          )[i].style.background = "#cc0000";
          this.setState({
            isAlreadySelected: true,
            isSelected: true,
            customerSelected: record.id,
            customerSelectedName: record.name,
            cusPoints: record.collectPoints,
          });
        }
      } else {
        document.getElementsByClassName("ant-table-row ant-table-row-level-0")[
          i
        ].style.background = "";
      }
    }
  };

  showModal = () => {
    let lang = localStorage.getItem("lang");
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    let clientId = localStorage.getItem("clientId");
    axios({
      url: API_URL + "branchsList",
      method: "GET",
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
      params: {
        clientId,
        lang,
      },
    }).then((res) => {
      this.setState({ branches: res.data });
    });
    axios({
      url: API_URL + "parametersListByParaType",
      method: "GET",
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
      params: {
        paraType: "GENDER",
        lang,
      },
    }).then((res) => {
      this.setState({ gender: res.data });
    });
    axios({
      url: API_URL + "parametersListByParaType",
      method: "GET",
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
      params: {
        paraType: "COUNTRY",
        lang,
      },
    }).then((res) => {
      this.setState({ country: res.data });
    });
    axios({
      url: API_URL + "parametersListByParaType",
      method: "GET",
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
      params: {
        paraType: "CUSTOMER_GROUP",
        lang,
      },
    }).then((res) => {
      this.setState({ customer_group: res.data });
    });
    this.setState({
      visible: true,
    });
  };
  getCities = (e) => {
    let lang = localStorage.getItem("lang");
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    axios({
      url: API_URL + "parametersListByParent",
      method: "GET",
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
      params: {
        parent: e,
        lang,
      },
    }).then((res) => {
      this.setState({ city: res.data });
    });
  };
  getDeliveryAreas = (e) => {
    let lang = localStorage.getItem("lang");
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    axios({
      url: API_URL + "parametersListByParent",
      method: "GET",
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
      params: {
        parent: e,
        lang,
      },
    }).then((res) => {
      this.setState({ getDeliveryAreas: res.data });
    });
  };
  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
    if (this.props.visible) {
      this.props.onBack();
    }
  };

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
    if (this.props.visible) {
      this.props.onBack();
    }
  };
  getPriceList = () => {
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    let history = this.props.history;
    var authOptions = {
      method: "POST",
      data: {
        lang: localStorage.getItem("lang"),
        clientId: localStorage.getItem("clientId"),
        name: "",
        nameAr: "",
        page: "0",
        size: "50",
        sortColumn: "",
        sortOrder: "DESC",
      },
      url: API_URL + "PriceListsByClient",
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    };
    let self = this;
    axios(authOptions)
      .then(function(response) {
        if (response.data.success) {
          self.setState({ pricelist: response.data.content });
        }
      })
      .catch(function(error) {
        //message.error(error.response.data.message);
      });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        let thiss = this;
        let accessToken = localStorage.getItem("accessToken");
        let tokenType = localStorage.getItem("tokenType");
        values.lang = localStorage.getItem("lang");
        values.client = localStorage.getItem("clientId");
        var authOptions = {
          method: "POST",
          data: values,
          url: API_URL + "createCustomer",
          headers: {
            Authorization: tokenType + " " + accessToken,
            "Content-Type": "application/json",
          },
        };
        authOptions.data.phoneNo = this.props.numval;
        console.log(authOptions.data.phoneNo, "authOptions.data");
        axios(authOptions)
          .then(async (response) => {
            if (response.data.success) {
              message.success(response.data.message);
              await thiss.setState({ loading: false, visible: false });
              this.props.onCustomerSelect({
                customerSelected: response.data.object.id,
                customerSelectedName: response.data.object.name,
                customerSelect: false,
                isSelected: true,
              });
              localStorage.setItem(
                `${this.props.tablenop}`,
                `${authOptions.data.name}`,
              );

              if (this.props.visible) {
                this.props.onBack();
              }
              //    await this.child.current.fetch();

              //     this.handleNavigation(response.data.object)
            } else {
              thiss.setState({ loading: false });
              message.error(response.data.message);
            }
          })
          .catch(function(error) {
            //message.error(error.response.data.message);
          });
      }
    });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const lang = this.props.language.INJAZ_POS_POS_SCREEN
      .CUSTOMER_SELECT_SCREEN;
    return (
      <React.Fragment>
        {this.state.visible && (
          <Form onSubmit={this.handleSubmit}>
            <Modal
              title={lang.LABELS.CREATE_CUSTOMER_MODAL_TITLE}
              onOk={this.handleOk}
              onCancel={this.handleCancel}
              visible={this.state.visible}
              className="ModalCustomerSelect"
              style={{
                height: "100%",
                borderRadius: 0,
                maxWidth: "100%",
                maxHeight: "100%",
                width: "100% !important",
              }}
              footer={[
                <Button key="back" onClick={this.handleCancel}>
                  {lang.BUTTONS.CANCEL}
                </Button>,
                <Button
                  htmlType="submit"
                  onClick={this.handleSubmit}
                  type="primary"
                  loading={this.state.loading}
                >
                  {lang.BUTTONS.CREATE}
                </Button>,
              ]}
            >
              <Row gutter={12}>
                <Col span="md-24">
                  <FormItem label={lang.LABELS.NAME}>
                    {getFieldDecorator("name", {
                      rules: [
                        { required: true, message: lang.ERR_MESSAGES.NAME },
                      ],
                    })(
                      <Input
                        ref={(input) => {
                          this.textInput = input;
                        }}
                        placeholder={lang.PLACEHOLDERS.NAME}
                      />,
                    )}
                  </FormItem>
                </Col>
                <Col span="md-24">
                  <FormItem label={lang.LABELS.PH_NUM}>
                    {getFieldDecorator("phoneNo", {
                      // rules: [{ required: true, message: lang.ERR_MESSAGES.PH_NUM }],
                    })(
                      <InputNumber
                        id="phonenum"
                        style={{ width: "100%" }}
                        placeholder={
                          !this.props.numval
                            ? lang.PLACEHOLDERS.PH_NUM
                            : this.props.numval
                        }
                      />,
                    )}
                  </FormItem>
                </Col>
                <Col span="md-24">
                  <FormItem label={lang.LABELS.EMAIL}>
                    {getFieldDecorator("email", {
                      rules: [
                        { required: false, message: lang.ERR_MESSAGES.EMAIL },
                      ],
                    })(
                      <Input
                        type="email"
                        style={{ width: "100%" }}
                        placeholder={lang.PLACEHOLDERS.EMAIL}
                      />,
                    )}
                  </FormItem>
                </Col>
                <Col span={"md-24"}>
                  <FormItem label={lang.LABELS.PRICELIST}>
                    {getFieldDecorator("priceList", {
                      rules: [{ required: false }],
                    })(
                      <Select
                        style={{ width: "100%", background: "#fff" }}
                        placeholder="Select Price List"
                      >
                        {this.state.pricelist
                          .filter((item) => !item.hide)
                          .map((item) => (
                            <Select.Option value={item.id} key={item.id}>
                              {item.name}
                            </Select.Option>
                          ))}
                      </Select>,
                    )}
                  </FormItem>
                </Col>
              </Row>
            </Modal>
          </Form>
        )}
        {!this.props.visible && (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <span>
                <Button onClick={this.props.onBack}>{lang.BUTTONS.BACK}</Button>
                <p
                  className={
                    this.state.isAlreadySelected ? "collectionPointShow" : ""
                  }
                  style={{ fontWeight: "700" }}
                >
                  {this.state.isAlreadySelected &&
                    ` ${lang.LABELS.COLL_POINTS +
                      "   " +
                      this.state.cusPoints}`}
                </p>
              </span>
              <p style={{ fontWeight: "700" }}>
                {lang.LABELS.PAGE_TITLE}
                {/* Customer Selection */}
              </p>
              <span>
                {this.state.isSelected ? (
                  <Button
                    className="successBtn"
                    style={{
                      marginRight: "10px",
                      fontSize: "18px",
                      lineHeight: "25px",
                    }}
                    onClick={() => this.props.onCustomerSelect(this.state)}
                  >
                    {lang.LABELS.UPDATE_CUSTOMER}
                  </Button>
                ) : (
                  <span />
                )}
                <Button
                  style={{
                    marginRight: "0px",
                    fontSize: "18px",
                    lineHeight: "25px",
                  }}
                  onClick={this.showModal}
                  className="successBtn"
                >
                  {lang.BUTTONS.CREATE_CUSTOMER}
                </Button>
              </span>
            </div>
            <CustpmerTable
              ref={this.child}
              handleNavigation={this.handleNavigation}
              language={this.props.language}
            />
          </>
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    posStorage: state.posStorage,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    posStorageAction: (payload) => dispatch(posStorageAction(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(Form.create()(CustomerSelect));
